import type { BreadcrumbItem } from '../types/breadcrumb'

/** AI 工作流列表页顶栏面包屑 */
export function buildWorkflowsPageBreadcrumbs(): BreadcrumbItem[] {
  return [
    { label: '首页', to: '/' },
    { label: 'AI 工作流' },
  ]
}

/** 编排器页：末级展示工作流名称，窄屏由 ResponsiveBreadcrumbNav 折叠 */
export function buildWorkflowBuilderBreadcrumbs(opts: {
  isNew: boolean
  name: string
  fallbackName?: string
}): BreadcrumbItem[] {
  const trimmed = opts.name.trim()
  const label = trimmed || opts.fallbackName || (opts.isNew ? '新建工作流' : '工作流编排')
  return [
    { label: '首页', to: '/' },
    { label: 'AI 工作流', to: '/workflows' },
    { label, title: trimmed || undefined },
  ]
}

/** 运行/模拟页：工作流名称可回到编排器，末级为「模拟运行」或「运行」 */
export function buildWorkflowRunBreadcrumbs(opts: {
  definitionName: string
  definitionPublicId: string | null
  simulated: boolean
}): BreadcrumbItem[] {
  const trimmed = opts.definitionName.trim()
  const name = trimmed || '工作流'
  const builderTo = opts.definitionPublicId
    ? `/workflows/builder/${encodeURIComponent(opts.definitionPublicId)}`
    : '/workflows'
  return [
    { label: '首页', to: '/' },
    { label: 'AI 工作流', to: '/workflows' },
    { label: name, to: builderTo, title: trimmed || undefined },
    { label: opts.simulated ? '模拟运行' : '运行' },
  ]
}
